


































































import _ from 'lodash';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { State, Getter, Mutation } from 'vuex-class';
import { VuexMutation, PayFrequencyValues, Person, Output, UI, Features, Constants, Copy } from '@/types';
import { PropertyGetter, IProperty, mapValidations } from './vs-props';

@Component({
  validations: mapValidations(['income', 'age', 'payFrequency']),
} as any)
export default class App extends Vue {
  public hasChangedAge = false;
  public hasChangedIncome = false;

  @State public inputs: Person;
  @State public ui: UI;
  @State public features: Features;
  @State public constants: Constants;
  @State public copy: Copy;

  @Getter public outputs: Output[];
  @Getter public maxOutputTotal: number;

  @PropertyGetter public income: Partial<IProperty<number>>;
  @PropertyGetter public age: Partial<IProperty<number>>;
  @PropertyGetter public payFrequency: Partial<IProperty<number>>;

  @Mutation public pushVisibleRate: VuexMutation<number>;

  public setIncome(value: number) {
    (this.income as any) = value;
    this.hasChangedIncome = true;
  }

  public setAge(value: number) {
    (this.age as any) = value;
    this.hasChangedAge = true;
  }

  get validAge() {
    const valid = this.hasChangedAge ? !this.age.$v.$invalid : true;
    return this.features.ageMatching ? valid : true;
  }

  get validIncome() {
    return this.hasChangedIncome ? !this.income.$v.$invalid : true;
  }

  get validPayFrequency() {
    return !this.payFrequency.$v.$invalid;
  }

  get showOutputs() {
    const age = this.features.ageMatching ?  this.hasChangedAge && !this.age.$v.$invalid : true;
    const income = this.hasChangedIncome && !this.income.$v.$invalid;
    return age && income;
  }
}
